var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.title || _vm.$slots.right)?_c('div',{staticClass:"flex items-center px-4 sm:px-6 py-4 border-b",class:{
      'justify-between': _vm.title,
      'justify-end': !_vm.title,
      'sm:py-5': !_vm.$slots.right,
    }},[(_vm.title)?_c('CTypo',{staticClass:"mr-3",attrs:{"el":"h3","tstyle":"headline"}},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_c('div',[_vm._t("right")],2)],1):_vm._e(),_c('dl',{staticClass:"px-4 sm:px-0 sm:divide-y sm:divide-gray-200"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }